import './sass/App.sass';

import React, { Component } from 'react';

import {
  Route,
  Switch,
} from 'react-router-dom';

import ContactsPage from './components/pages/ContactsPage/ContactsPageWrapper';
import E404 from './components/pages/e404/e404';
import HistoryPage from './components/pages/HistoryPage/history';
import HomePage from './components/pages/HomePage/HomePageWrapper';
import MoviePage from './components/pages/MoviePage/MoviePageWrapper';
import SessionsPage from './components/pages/SessionsPage/SessionsPageWrapper';
import SoonPage from './components/pages/SoonPage';
import AutoRefund from './components/snippets/AutoRefund';
import Footer from './components/snippets/Footer';
import Header from './components/snippets/Header';
import ManualRefund from './components/snippets/ManualRefund';
import MobHeader from './components/snippets/MobHeader';
import MobMenu from './components/snippets/MobMenu';
import Trailer from './components/snippets/Trailer';
import Widget from './components/snippets/Widget';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      films: props.films,
      filmsById: props.filmsById,
      scheduleDates: props.scheduleDates,
      halls: props.halls,
      hallsById: props.hallsById,
      formats: props.formats,
      formatsById: props.formatsById,
      widgetSession: props.widgetSession,
      trailerFilmId: props.trailerFilmId,
      mobMenuOpen: props.mobMenuOpen,
      is404: props.is404,
      manualRefundVisible: false,
      autoRefundVisible: false,
      autoRefundError: false,
      soon: props.soon,
    };

    this.handleSessionClick = this.handleSessionClick.bind(this);
    this.closeWidget = this.closeWidget.bind(this);
    this.openTrailer = this.openTrailer.bind(this);
    this.closeTrailer = this.closeTrailer.bind(this);
    this.toggleMobMenu = this.toggleMobMenu.bind(this);
    this.showManualRefund = this.showManualRefund.bind(this);
    this.hideManualRefund = this.hideManualRefund.bind(this);
    this.showAutoRefund = this.showAutoRefund.bind(this);
    this.hideAutoRefund = this.hideAutoRefund.bind(this);
    this.autoToManualRefund = this.autoToManualRefund.bind(this);
    this.setAutoRefundError = this.setAutoRefundError.bind(this);
    this.resetAutoRefundError = this.resetAutoRefundError.bind(this);
  }

  // реакция на клик по сеансу
  handleSessionClick(session) {
    this.setState({ widgetSession: session });
  }

  // закрытие виджета
  closeWidget() {
    this.setState({ widgetSession: null });
  }

  // открытие трейлера
  openTrailer(filmId) {
    this.setState({ trailerFilmId: filmId });
  }

  // закрытие трейлера
  closeTrailer(filmId) {
    this.setState({ trailerFilmId: null });
  }

  // переключение моб меню
  toggleMobMenu() {
    this.setState(prevState => {
      return { mobMenuOpen: !prevState.mobMenuOpen };
    });
  }

  showManualRefund() {
    this.setState({ manualRefundVisible: true });
  }

  hideManualRefund() {
    this.setState({ manualRefundVisible: false });
  }

  showAutoRefund() {
    this.setState({ autoRefundVisible: true });
  }

  hideAutoRefund() {
    this.setState({ autoRefundVisible: false });
  }

  autoToManualRefund() {
    this.hideAutoRefund();
    this.showManualRefund();
  }

  setAutoRefundError() {
    this.setState({ autoRefundError: true });
  }

  resetAutoRefundError() {
    this.setState({ autoRefundError: false });
  }

  getCurrentFilm(filmId) {
    const { filmsById, soon } = this.state;
    return filmsById[filmId] ? filmsById[filmId] : soon.filmsById[filmId];
  }

  render() {
    return (
      <div className="App">
        <div className="wrapper">
          <div>
            <Header
              is404={this.props.is404}
            />
            <MobHeader
              toggleMenu={this.toggleMobMenu}
              is404={this.props.is404}
            />
            {this.state.mobMenuOpen && <MobMenu toggleMenu={this.toggleMobMenu} is404={this.props.is404} />}
            {
              (this.state.filmsById && !this.props.is404) && (
                <Switch>
                  <Route
                    exact path="/"
                    render={() => (
                      <HomePage
                        films={this.state.films}
                        dates={this.state.scheduleDates}
                        halls={this.state.halls}
                        formats={this.state.formats}
                        hallsById={this.state.hallsById}
                        formatsById={this.state.formatsById}
                        handleSessionClick={this.handleSessionClick}
                        openTrailer={this.openTrailer}
                      />
                    )} />
                  <Route
                    path="/movie/:id"
                    render={(props) => {
                      const currentFilm = this.getCurrentFilm(props.match.params.id);
                      if (!currentFilm) {
                        return <E404 />;
                      }
                      return (
                        <MoviePage
                          {...props}
                          film={currentFilm}
                          films={this.state.films}
                          dates={this.state.scheduleDates}
                          handleSessionClick={this.handleSessionClick}
                          openTrailer={this.openTrailer}
                        />
                      );
                    }} />
                  <Route
                    exact
                    path="/sessions"
                    render={() => (
                      <SessionsPage
                        films={this.state.films}
                        dates={this.state.scheduleDates}
                        halls={this.state.halls}
                        formats={this.state.formats}
                        hallsById={this.state.hallsById}
                        formatsById={this.state.formatsById}
                        handleSessionClick={this.handleSessionClick}
                      />
                    )} />
                  <Route
                    exact
                    path="/contacts"
                    render={() => <ContactsPage />}
                  />
                  {/* <Route
                    exact
                    path="/cafe"
                    render={() => <CafePage />}
                  />                   */}
                  <Route
                    exact
                    path="/widget/:fid/:sid"
                    render={(props) => {
                      const currentFilm = this.getCurrentFilm(props.match.params.fid);
                      if (!currentFilm) {
                        return <E404 />;
                      }
                      return (
                        <MoviePage
                          {...props}
                          film={currentFilm}
                          wsid={props.match.params.sid}
                          films={this.state.films}
                          dates={this.state.scheduleDates}
                          handleSessionClick={this.handleSessionClick}
                          openTrailer={this.openTrailer}
                        />
                      );
                    }} />
                  <Route
                    exact
                    path="/soon"
                    render={(props) => <SoonPage soon={this.state.soon} {...props} />}
                  />
                  <Route
                    exact
                    path="/history"
                    render={() => <HistoryPage />}
                  />
                </Switch>
              )
            }
            {this.props.is404 && <E404 />}
            {
              this.state.widgetSession
              && this.state.filmsById[this.state.widgetSession.FilmId]
              && (
                <Widget
                  sessionId={this.state.widgetSession.Id}
                  cinemaId={this.state.widgetSession.CinemaId}
                  filmId={this.state.widgetSession.FilmId}
                  filmName={this.state.filmsById[this.state.widgetSession.FilmId].Name}
                  hallName={this.state.widgetSession.hall_name}
                  close={this.closeWidget}
                />
              )
            }
            {this.state.trailerFilmId && (
              <Trailer
                filmId={this.state.trailerFilmId}
                filmName={this.getCurrentFilm(this.state.trailerFilmId).Name}
                close={this.closeTrailer}
                trailerUrl={this.getCurrentFilm(this.state.trailerFilmId).TrailerUrl}
              />
            )}
            {this.state.manualRefundVisible && (
              <ManualRefund
                hideManualRefund={this.hideManualRefund}
                resetAutoRefundError={this.resetAutoRefundError}
                autoRefundError={this.state.autoRefundError}
              />
            )}
            {this.state.autoRefundVisible && (
              <AutoRefund
                hideAutoRefund={this.hideAutoRefund}
                autoToManualRefund={this.autoToManualRefund}
                setAutoRefundError={this.setAutoRefundError}
              />
            )}
          </div>
          <div className="buffer"></div>
        </div>
        <Footer showAutoRefund={this.showAutoRefund} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js